// extracted by mini-css-extract-plugin
module.exports = {"steps":"index_steps__27m8J","steps-content":"index_steps-content__1woR6","steps-action":"index_steps-action__jwF0c","btn":"index_btn__2pq3b"};